import { OfferType } from '../../../common/enums.js';
import { getFixedBroadbandModalContent } from '../../ProductOfferingModalCoCo/ProductOfferingsModalContentCoCo/FixedBroadbandModalContent.js';
import { getMobileBroadbandModalContent } from '../../ProductOfferingModalCoCo/ProductOfferingsModalContentCoCo/MobileBroadbandModalContent.js';
import { getMobileVoiceModalContent } from '../../ProductOfferingModalCoCo/ProductOfferingsModalContentCoCo/MobileVoiceModalContent.js';
import { getSoftwareProductModalContent } from '../../ProductOfferingModalCoCo/ProductOfferingsModalContentCoCo/SoftwareProductModalContent.js';
import { getFixedBroadbandCardContent } from './FixedBroadbandCardContent.js';
import { getMobileBroadbandCardContent } from './MobileBroadbandCardContent.js';
import { getMobileVoiceCardContent } from './MobileVoiceCardContent.js';
import { getSoftwareProductCardContent } from './SoftwareProductCardContent.js';
import type { ProductContentRendererCoCo } from './types.js';

const defaultRenderer: ProductContentRendererCoCo = {
  offerType: OfferType.VOICE,
  getCardContent: getMobileVoiceCardContent,
  getModalDescriptionItems: getMobileVoiceModalContent,
};

const renderers: Partial<Record<OfferType, ProductContentRendererCoCo>> = {
  [OfferType.VOICE]: {
    offerType: OfferType.VOICE,
    getCardContent: getMobileVoiceCardContent,
    getModalDescriptionItems: getMobileVoiceModalContent,
  },
  [OfferType.MOBILE_BROADBAND]: {
    offerType: OfferType.MOBILE_BROADBAND,
    getCardContent: getMobileBroadbandCardContent,
    getModalDescriptionItems: getMobileBroadbandModalContent,
  },
  [OfferType.SOFTWARE]: {
    offerType: OfferType.SOFTWARE,
    getCardContent: getSoftwareProductCardContent,
    getModalDescriptionItems: getSoftwareProductModalContent,
  },
  [OfferType.FIXED_BB]: {
    offerType: OfferType.FIXED_BB,
    getCardContent: getFixedBroadbandCardContent,
    getModalDescriptionItems: getFixedBroadbandModalContent,
  },
};

export const getOfferTypeContentRendererCoCo = (offerType: OfferType): ProductContentRendererCoCo => {
  return renderers[offerType] ?? defaultRenderer;
};
